import { Observable } from "rxjs";
import { get, post, put } from "@utils/axios";
import sessionService from "./session.service";

class MemberDetailsService {
  dataCardIds: any = [];
  isPinUnpin = false;
  set setDataCardIdList(ids: any) {
    this.dataCardIds = ids;
  }
  get getDataCardIdList() {
    return this.dataCardIds;
  }

  set setIsPinUnpin(flag: boolean) {
    this.isPinUnpin = flag;
  }
  get getIsPinUnpin() {
    return this.isPinUnpin;
  }

  fetchReminderNotifications() {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/reminder/notification`);
  }

  // private _subject: BehaviorSubject<any> = new BehaviorSubject(false);
  getOverviewRecords(id: number): Observable<any> {
    let param = `id=${id}`;
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/getOverviewRecords?${param}`);
  }

  getEolRecords(id: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/eol`, {
      memberId: id
    });
  }

  getMemberDetailsRecords(id: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/member-details`, {
      memberId: id
    });
  }

  getPatientProfileMatrixRecords(id: number): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/profile-management-matrix`, {
      memberId: id
    });
  }

  getKeyNumbersRecords(id: number): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/key-numbers`, {
      memberId: id
    });
  }

  fetchVitals(patientID: string): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/vitals`, {
      memberId: patientID
    });
  }

  fetchVitalsGraph(patientID: string, vital: string): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/vitals/fetch-graph-info?vital=${vital}`, {
      memberId: patientID
    });
  }

  updateVital(patientId: string, value: any, date: string): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/vitals/update`, {
      patientId,
      value,
      date,
    });
  }

  fetchLabs(
    patientId: string,
    fetchRedValues: boolean = false,
    page: number = 0,
    limit: number = 0,
    sortBy?: string,
    sortType?: "ASC" | "DESC",
    searchOn?: Array<{
      columnName: string;
      searchText: string;
    }>
  ) {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/labs?page=${page}&limit=${limit}&sortBy=${sortBy}&sortType=${sortType}`, {
      patientId,
      fetchRedValues,
      searchOn,
    });
  }

  updateStatus(patientId: any, status: any): Observable<any> {
    return put(`${sessionService.getClient()?.appServiceUrl}/patient/update-status`, {
      patientId: patientId,
      status: status,
    });
  }

  getActionableInsightRecords(id: number): Observable<any> {
    let param = `id=${id}`;
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/getActionableInsightRecords?${param}`);
  }

  getAlternateMedication(id: number) {
    let param = `patientId=${id}`;
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/alternate-medication?${param}`);
  }
  updateAlternateMedication(id: number, medicationName: string, genericDrugName: string, genericDrugBrand: string, isAccepted: any, isRejected: any, isStatusOnly: boolean, ndcNumber: any) {
    return put(`${sessionService.getClient()?.appServiceUrl}/patient/alternate-medication`, {
      patientId: id,
      medicationName: medicationName,
      genericMedicationName: genericDrugName,
      genericMedicationBrand: genericDrugBrand,
      isAccepted: isAccepted,
      isRejected: isRejected,
      isStatusOnly: isStatusOnly,
      ndcNumber: ndcNumber,
    });
  }

  getContactDetails(id: number): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/getContactDetails`, {
      memberId: id
    });
  }

  getSocialDeterminantsInfo(id: number): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/fetchSocialDeterminantsInfo`, {
      memberId: id
    });
  }

  getQuestionList(id: number): Observable<any> {
    let param = `id=${id}`;
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/HRA/fetchQuestionList?${param}`);
  }

  submitAnswers(patientId: any, questionAnswerList: any[]): Observable<any> {
    let updated = [...questionAnswerList].map((item: any) => {
      // delete item.questionDescription;
      return item;
    });
    return put(`${sessionService.getClient()?.appServiceUrl}/patient/HRA/submitAnswers`, {
      patientId: patientId,
      questionAnswerList: updated,
    });
  }

  getAllPatientRecords(id: number): Observable<any> {
    let param = `id=${id}`;
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/getAllPatientRecords?${param}`);
  }

  getDataCardDetails(id: number, dataCardType: string): Observable<any> {
    let param = `id=${id}&dataCard=${dataCardType}`;
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/getDataCardDetails?${param}`);
  }

  getRiskScore(id: number): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/member-details/risk-score`,{
      memberId: id
    });
  }

  getMedicalHistoryData(patientId: number, fromDate?: any, toDate?: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/medicalHistory`, {
      patientId: patientId,
      fromDate: fromDate,
      toDate: toDate,
    });
  }

  getMedicalHistoryDataDownload(payload: { patientId: number; fromDate: any; toDate: any; isDownload: boolean; tabName: string }): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/medicalHistory`, {
      ...payload,
    });
  }

  getEncounterInfo(id: number, page?: number, limit?: number, sortBy?: any, sortType?: any, searchBy?: any, searchKeyword?: any, claim_type?: any, reminderStartFilter?:any, reminderEndFilter?:any): Observable<any> {
    let body: any = { id };
    if (page && limit) {
      body.page = page - 1;
      body.limit = limit;
    }
    if (sortBy && sortType) {
      body.sortBy = sortBy;
      body.sortType = sortType;
    }
    if (searchBy && searchKeyword) {
      body.searchBy = searchBy;
      body.searchKeyword = searchKeyword;
    }
    if (claim_type) {
      body.claim_type = claim_type;
    }
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/fetchEncountersData`, {...body, minDate: reminderStartFilter, maxDate: reminderEndFilter });
  }

  getEncounterInfoDownload(id: number, sortBy?: any, sortType?: any, searchBy?: any, searchKeyword?: any, claim_type?: any, reminderStartFilter?: any, reminderEndFilter?: any ): Observable<any> {
    let body: any = { id };

    if (sortBy && sortType) {
      body.sortBy = sortBy;
      body.sortType = sortType;
    }
    if (searchBy && searchKeyword) {
      body.searchBy = searchBy;
      body.searchKeyword = searchKeyword;
    }
    if (claim_type) {
      body.claim_type = claim_type;
    }
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/fetchEncountersDataDownload`, { ...body, minDate: reminderStartFilter, maxDate: reminderEndFilter });
  }

  pinUnPinDataCard(dataCardId: number, action: any): Observable<any> {
    return put(`${sessionService.getClient()?.appServiceUrl}/patient/my-dashboard`, {
      dataCardId: dataCardId,
      action: action,
    });
  }

  getDataCardIds(): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/datacard-ids`);
  }

  getMyDashboardRecords(id: number): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/my-dashboard`, {
      memberId: id
    });
  }

  getAdtFeeds(id: number, startDate: string, endDate: string): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/adt-details?startDate=${startDate}&endDate=${endDate}`, {
      memberId: id
    });
  }

  recommendations(id: number, desc: any, status: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/actionable-insights/recommendations`, {
      patientId: Number(id),
      description: desc,
      status: status,
    });
  }

  getColumnsList(): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/column-list?pageName=ADT Feed`);
  }

  updateAdtColumns(columns: any[]): Observable<any> {
    return put(`${sessionService.getClient()?.appServiceUrl}/patient/column-preference?pageName=ADT Feed`, { columns: columns });
  }

  submitKinData(patientId: any, kinDetails: Object): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/kins-information`, {
      patientID: patientId,
      ...kinDetails,
    });
  }

  revertrecommendations(id: number, desc: any, status: any): Observable<any> {
    return put(`${sessionService.getClient()?.appServiceUrl}/patient/actionable-insights/recommendations/revert`, {
      patientId: Number(id),
      description: desc,
      status: status,
    });
  }

  fetchUtilizationReviewReportInfo(patientId: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/patientProfileReport/fetchUtilizationReviewReportInfo`, {
      patient_id: patientId,
    });
  }

  sendUtilizationReviewReport(emails: string[], pdf: string, patientName: string): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/patientProfileReport/sendUtilizationReviewReport`, {
      emails,
      pdf,
      patientName,
    });
  }

  updatePatientProfile(patientID: number, isChecked: boolean, category: string, fieldName: string): Observable<any> {
    return put(`${sessionService.getClient()?.appServiceUrl}/patient/patient-profile`, {
      patientID,
      isChecked: isChecked ? "true" : "false",
      category,
      fieldName,
    });
  }

  fetchRiskScore(patientID: number, type: string): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/risk-score?type=${type}`, {
      memberId: patientID
    });
  }

  fetchRiskScoreFactorDetails(patientID: number, type: string, factor: number): Observable<any> {
    // patientID=9999991
    // let param = `id=${id}`
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/risk-score/factor-details`, {
      params: {
        patientID,
        type,
        factor,
      },
    });
  }

  fetchAttributeDropdown(atrributeName: string, patientId?: string, interventionId?: number, subTaskId?: number, type?: string, additionalData?: any) {
    let param = `attr_key_val=${atrributeName}`;
    param = type ? `${param}&type=${type}` : param;
    return post(`${sessionService.getClient()?.appServiceUrl}/common/fetch-dropdown?${param}`, {
      patientId: patientId,
      intervId: interventionId,
      subtaskId: subTaskId,
      additionalData: additionalData || {},
    });
  }

  fetchClassificationStatusList(patientId?: string) {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/getClassification`, {
      memberId: patientId
    });
  }

  fetchCaseStatusActiveDropdown(attributeName: string) {
    let param = `attr_key_val=${attributeName}`;
    return post(`${sessionService.getClient()?.appServiceUrl}/common/fetch-dropdown?${param}`);
  }

  fetchAttributeDropdownWithSqParams({ attributeName, sqlParamsFromPayload }: any) {
    let param = `attr_key_val=${attributeName}`;
    return post(`${sessionService.getClient()?.appServiceUrl}/common/fetch-dropdown?${param}`, {
      sqlParamsFromPayload,
    });
  }

  updateSelectedAttribute(data: any) {
    return post(`${sessionService.getClient()?.appServiceUrl}/common/update-attribute`, {
      ...data,
    });
  }

  getReferrals(patientId: string | number) {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/getReferrals`, {
      patientId,
    });
  }

  updateReferrals({ patientId, status, assignee }: { patientId: string | number; status: { status: string }; assignee: { assignee: string } }) {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/updateReferrals`, {
      patientId,
      status,
      assignee,
    });
  }

  addSupplementalData(payload: any) {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/addSupplementalData`, {
      ...payload,
    });
  }

  fetchHealthPlanInput() {
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/healthPlanField`);
  }

  getFieldsForSupplementalFile(fieldValue: any) {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/getFieldsForSupplementalFile`, {
      fieldValue: fieldValue,
    });
  }

  fetchSummary(patientId: any, fromDate: any, toDate: any) {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/getSummary`, {
      patientId: patientId,
      fromDate: fromDate,
      toDate: toDate,
    });
  }

  getContactInfoForCoordinator(patientId: number): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/coordinator-contact-details`, {
      memberId: patientId
    });
  }

  submitContactData(patientId: any, contactDetails: Object): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/update/contact-details`, {
      patientId,
      ...contactDetails,
    });
  }

  getProvidersSummary(patientId: number): Observable<any> {
    let param = `patientId=${patientId}`;
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/getProviderSummary?${param}`);
  }

  fetchSummaryReport(patientId: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/summaryReport`, {
      patient_id: patientId,
    });
  }

  gethHealthPlanCareGapsInfo(patientID: any, selectedYear: any): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/getHealthPlanCareGaps?patientId=${patientID}&selectedYear=${selectedYear}`);
  }

  createHealthPlanNote(patientID: any, measureId: any, category: string, note: any, selectedYear: any, sectionName: string): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/create-healthPlanCareGapsNote`, {
      patientId:patientID,
      measureId,
      category,
      note,
      selectedYear,
      sectionName
    });
  }

  updateHealthPlanCategory(patientID: any, measureId: any, previousCategory: any, category: string, selectedYear: any, sectionName: string): Observable<any> {
    return put(`${sessionService.getClient()?.appServiceUrl}/patient/update-healthPlanCareGapsCategory`, {
      patientId:patientID,
      measureId,
      previousCategory,
      category,
      selectedYear,
      sectionName
    });
  }

  getPayerHistory(patientId: number): Observable<any> {
    let param = `patientId=${patientId}`;
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/getPayerHistory?${param}`);
  }
}

export default new MemberDetailsService();
